import React, { useEffect, useState, useRef } from 'react';
import { useTenancy } from '@/contexts/TenancyContext';
import ISMSRolesTable from '@/components/ISMSRolesTable';
import { fetchISMSRoles, onISMSRolesChange, ISMSRole } from '@/services/ismsRolesService';
// import { db } from '@/js/external-js/config/main_config';
import { db } from '@/js/external-js/config/main_config';
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion';
import { Separator } from "@/components/ui/separator"

import EditableField from '@/components/ui/EditableField';
import { FrameworkBadge } from '@/app/pages/msg/components/FrameworkBadge';
import { getAllModules } from '@/app/pages/msg/utils/common';
import { fetchRelatedDocuments, populateCustomContent, fetchPageContentMDX } from '@/app/pages/msg/utils/common';
import { useMarkdownComponents } from '@/app/pages/msg/components/MDXFields';
import { MarkdownRenderer } from '@/app/pages/msg/components/MarkdownRenderer';
import RelatedClausesAccordianItem from '@/app/pages/msg/components/RelatedClauses';
import { useMSGVersion } from '../../hooks/useMSGVersion';
import AdditionalContent from '../../components/AdditionalContent';
import FootNote from '../../components/FootNote';
import SupportingDocs from '../../components/SupportingDocs';
import SupportingDocsDropdown from '../../components/SupportingDocsDropdown';

export default function Roles() {
  const { activeTenancy } = useTenancy();
  const { incrementVersion } = useMSGVersion();

  const clauseStandards = useRef<Set<string>>(new Set());

  const [pageTemplate, setPageTemplate] = React.useState<string>('');
  const [supportingDocs, setSupportingDocs] = React.useState([]);
  const [sortedFrameworks, setSortedFrameworks] = React.useState([]);
  const [dynamicStandardNames, setDynamicStandardNames] = useState<Map<string, string>>(new Map());
  const [dynamicContent, setDynamicContent] = React.useState<string>("");

  const [modulesList, setModulesList] = useState([]);
  const [ismsRoles, setISMSRoles] = useState<ISMSRole[]>([]);
  const pageName = 'support';
  const contentPath = 'roles';
  const pageRoute = '/MSG/support/roles';

  const [pageClauses, setPageClauses] = useState<Set<string>>(new Set());

  // Function to update pageClauses
  const updatePageClauses = (newClauses: Set<string>) => {
    setPageClauses(new Set(newClauses));
  };


  useEffect(() => {
    if (!activeTenancy.id) return;

    const pageContent = fetchPageContentMDX(db, pageName, contentPath, activeTenancy, setPageTemplate);

    const getRelatedDocuments = fetchRelatedDocuments(db, activeTenancy.id, pageRoute, setSupportingDocs);

    const getCustomContent = populateCustomContent(db, activeTenancy.id, pageRoute, setDynamicContent);

    const load = async () => {
      const loadModules = async () => {
        const allModules = await getAllModules();
        const storedVisibilities = JSON.parse(localStorage.getItem('modulesVisibility') || '{}');

        allModules.forEach(module => {
          module.visible = storedVisibilities[module.id] ?? false;
        });

        setModulesList(allModules);
      }
      loadModules();
    }; load();

    const unsubscribe = onISMSRolesChange(activeTenancy.id, setISMSRoles);

    return () => {
      pageContent();
      getCustomContent();
      getRelatedDocuments();
      if (unsubscribe) unsubscribe();
    };
  }, [activeTenancy]);

  return (
    <div className="space-y-6">
      <div className="bg-card rounded-xl border border-border shadow-sm px-6 py-6">
        <div className="absolute right-4 top-4 z-10">
          <div className="flex items-center space-x-2">
            <SupportingDocsDropdown pageRoute={pageRoute} clauseStandards={clauseStandards} pageClauses={pageClauses} />
            <RelatedClausesAccordianItem modulesList={modulesList} clauseStandards={clauseStandards} setModulesList={setModulesList} />
          </div>
        </div>
        <div className="px-6 py-6">
          <MarkdownRenderer source={pageTemplate} components={useMarkdownComponents(modulesList, clauseStandards, { current: pageClauses }, updatePageClauses)} />
        </div>
        {/* <EditableField
          label="Additional Content"
          type="text"
          value={dynamicContent}
          onSave={async (newValue) => {
            const oldValue = dynamicContent;
            setDynamicContent(newValue);
            const editorDocRef = db.collection('customers')
              .doc(activeTenancy.id)
              .collection('product')
              .doc('managementSystemGuide')
              .collection('editor')
              .doc('content');
            try {
              await editorDocRef.set({ [pageRoute]: { content: newValue } }, { merge: true });
              await incrementVersion(
                'additional_content_update',
                `Updated additional content on ${pageRoute}`,
                { pageRoute, oldContent: oldValue, newContent: newValue }
              );
            } catch (e) {
              console.error('[Support/Roles] Save/version update failed:', e);
            }
          }}
        /> */}
        <div style={{ maxWidth: '56rem', marginLeft: 'auto', marginRight: 'auto', padding: '0px 1rem 1.5rem', transition: 'color 0.2s, background-color 0.2s', backgroundColor: 'transparent' }}>
          <AdditionalContent pageRoute={pageRoute} />
          <FootNote />
        </div>
        <div className="mt-10">
          <h3 className="text-lg font-semibold mb-2">MSG Roles</h3>
          <ISMSRolesTable roles={ismsRoles} />
        </div>
        {/* TODO: @Joe - Style accordion */}
        {/* <Accordion type="multiple" className="w-full divide-y-0 border-none">
          <AccordionItem value="item-1" className="border-none">
            <AccordionTrigger className="flex justify-end ml-auto">Supporting Documentation</AccordionTrigger>
            <AccordionContent>
              <Separator />
              {supportingDocs.length === 0 && (
                <span className="file-name">No matching documents found</span>
              )}
              <ul className="file-list">
                {supportingDocs.map((doc: any) => (
                  <li key={doc.docID}>
                    {doc.fileName}
                    {doc.procRef?.map((ref: any) => (
                      <FrameworkBadge key={ref} refId={ref} />
                    ))}
                  </li>
                ))}
              </ul>
            </AccordionContent>
          </AccordionItem>
          <RelatedClausesAccordianItem modulesList={modulesList} clauseStandards={clauseStandards} setModulesList={setModulesList} />
        </Accordion> */}
        {/* <div className='bg-card rounded-xl border border-border shadow-sm overflow-hidden'>
          <SupportingDocs pageRoute={pageRoute} clauseStandards={clauseStandards} pageClauses={pageClauses} />
        </div> */}
      </div>
    </div>
  );
}
